export default errorValue => `${errorValue[0]}`;
